import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "hostro_access_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (t) => {
    try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* */ }
  },
};

const api = axios.create({
  baseURL: API,
  // NOTE: withCredentials intentionally OFF. We use Bearer tokens (Authorization header).
  // Keeping it on causes a CORS failure on hostro.in because the production ingress sets
  // Access-Control-Allow-Origin: * which is incompatible with credentials mode.
  withCredentials: false,
});

// Inject Authorization header on every request if token exists.
// This bypasses the CORS cookie issue caused by ingress wildcard.
api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// If a 401 comes back, clear stale token so user re-auths cleanly.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Don't auto-redirect — let AuthContext handle UI.
      const url = err.config?.url || "";
      if (!url.includes("/auth/me") && !url.includes("/auth/refresh")) {
        // keep token for /auth/me probe so we know if it's invalid
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Inject Cloudinary delivery transforms (q_auto, f_auto + optional resize) into any
 * res.cloudinary.com URL. Returns the original URL for non-Cloudinary sources.
 */
export function cldOptimize(url, transform = "") {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com")) return url;
  if (url.includes("/upload/q_auto")) return url;
  const t = ["q_auto", "f_auto", transform].filter(Boolean).join(",");
  return url.replace("/upload/", `/upload/${t}/`);
}

export default api;
